import { faEraser, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProcedureSearch } from "@/api/procedures";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";

const defaultFilters: ProcedureSearch = {
  standard: "",
  recordType: "",
  recordNumber: "",
};

export function FilterPanel() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState<ProcedureSearch>({
    standard: searchParams.get("standard") || defaultFilters.standard,
    recordType: searchParams.get("recordType") || defaultFilters.recordType,
    recordNumber: searchParams.get("recordNumber") || defaultFilters.recordNumber,
  });

  function handleReset() {
    setFilters(defaultFilters);
    setSearchParams();
  }

  function handleSearch(e: React.FormEvent) {
    e.preventDefault();
    setSearchParams(new URLSearchParams(filters));
  }

  function handleFilterChanged(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
    const fieldName = e.currentTarget.id;
    const newValue = e.currentTarget.value;

    setFilters((prev) => ({ ...prev, [fieldName]: newValue }));
  }

  return (
    <div>
      <form onSubmit={handleSearch}>
        <button className="btn btn-default search" title="Apply filter">
          Apply filter <FontAwesomeIcon icon={faFilter} />
        </button>
        <button type="button" onClick={handleReset} className="btn btn-light clear" title="Clear filter">
          Clear <FontAwesomeIcon icon={faEraser} />
        </button>
        <hr />

        <div className="mb-2">
          <label htmlFor="standard" className="form-label">
            Record standard
          </label>
          <select id="standard" className="form-select" value={filters.standard} onChange={handleFilterChanged}>
            <option />
            <option>API</option>
            <option>ASME</option>
            <option>AWS</option>
            <option>ISO</option>
          </select>
        </div>
        <div className="mb-2">
          <label htmlFor="recordType" className="form-label">
            Record type
          </label>
          <select id="recordType" className="form-select" value={filters.recordType} onChange={handleFilterChanged}>
            <option />
            <option>WPS</option>
            <option>PQR</option>
          </select>
        </div>
        <div className="mb-2">
          <label htmlFor="recordNumber" className="form-label">
            Record number
          </label>
          <input
            className="form-control"
            id="recordNumber"
            value={filters.recordNumber}
            onChange={handleFilterChanged}
          />
        </div>
      </form>
    </div>
  );
}
